import { Map } from 'immutable'
import {
  SET_LISTS_PROCESSING,
  SET_LISTS_ERROR,
  UPDATE_LISTS_SUCCESS,
  SET_LIST_DATA,
  SET_LISTS_DATA,
  SET_NEW_LIST,
  SET_UPDATED_LIST,
} from './actions'

export const initialState = Map()

export default (state = initialState, action) => {
  const { payload, type } = action
  switch (type) {
    case SET_LISTS_PROCESSING:
      return state.setIn(['processing'], payload.processing)
    case SET_LIST_DATA:
      return state
        .set('lists', payload.data)
        .setIn(['processing'], false)
    case SET_LISTS_DATA:
      return state
        .set('lists', payload.data)
        .setIn(['processing'], false)
    case SET_LISTS_ERROR:
      return state
        .setIn(['error'], payload.error)
        .setIn(['processing'], false)
    case UPDATE_LISTS_SUCCESS:
      return state
        .setIn(['success'], true)
        .setIn(['processing'], false)
    case SET_NEW_LIST:
      return state
        .set('newList', payload)
    case SET_UPDATED_LIST:
      return state
        .set('updatedList', payload)
    default:
      return state
  }
}
